import React from 'react';

import { Link as MUILink } from '@mui/material';
import { Link } from 'react-router-dom';

interface RouterLinkProps {
  to?: string;
  children: React.ReactNode;
  href?: string;
  style?: React.CSSProperties;
}

const RouterLink: React.FC<RouterLinkProps> = ({ to, href, children, ...props }) => {

  if (href) {
    return <MUILink href={href} {...props}>{children}</MUILink>;
  }

  return <Link to={to ?? ""} {...props}>{children}</Link>;
};

export default RouterLink;